import {Service, Module} from 'app/decorators.js';
import R from 'app/resource';
import BaseStore from './base';


@Module({
    name: 'app.store.product.rate',
    modules: [
        R,
    ],
})
@Service('ProductRateStore')
export default class Store extends BaseStore {
    constructor ($q, R) {
        "ngInject";
        super($q, R);
        this.endpoint = this.R.all('products-rate');
    }

    checkProducts (data) {
        let self = this;
        let $promise = null;

        this.loading = true;
        $promise = this.endpoint.post(data);
        $promise.finally(() => { self.loading = false });
        return $promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/stores/product.rate.js